import { render, staticRenderFns } from "./AddStockAdjustment.vue?vue&type=template&id=03a4c8cc&"
import script from "./AddStockAdjustment.vue?vue&type=script&lang=js&"
export * from "./AddStockAdjustment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports